import React, {
  useMemo,
  useState,
  useReducer,
  useCallback,
  useRef,
} from 'react';
import {
  BreadcrumbsContextProvider,
  HeaderReferences,
  IBreadcrumbsContext,
} from '../../../_Common/Components/RutinBreadcrumbs/BreadcrumbsContext';
import {
  navlevelsReducer,
  topNavLevel,
  topBreadcrumbNavLevel,
  INavLevelEntry,
} from '../../../_StandardRutin/StandardRutinUtils';

const BreadcrumbsWrapper: React.FC<React.PropsWithChildren<{}>> = props => {
  // refs för alla headers (undvik loopar för devtools)
  const headerRef1 = useRef<HTMLLIElement>(null);
  const headerRef2 = useRef<HTMLLIElement>(null);
  const headerRef3 = useRef<HTMLLIElement>(null);
  const headerRef4 = useRef<HTMLLIElement>(null);
  const headerRef5 = useRef<HTMLLIElement>(null);
  const headerRef6 = useRef<HTMLLIElement>(null);
  const headerRef7 = useRef<HTMLLIElement>(null);
  const headerRef8 = useRef<HTMLLIElement>(null);
  const headerRef9 = useRef<HTMLLIElement>(null);
  const headerRef10 = useRef<HTMLLIElement>(null);
  const headerRef11 = useRef<HTMLLIElement>(null);
  const headerRef12 = useRef<HTMLLIElement>(null);
  const headerRef13 = useRef<HTMLLIElement>(null);
  const headerRef14 = useRef<HTMLLIElement>(null);
  const headerRef15 = useRef<HTMLLIElement>(null);
  const headerRef16 = useRef<HTMLLIElement>(null);
  const headerRef17 = useRef<HTMLLIElement>(null);
  const headerRef18 = useRef<HTMLLIElement>(null);
  const headerRef19 = useRef<HTMLLIElement>(null);
  const headerRef20 = useRef<HTMLLIElement>(null);

  const separatorRef1 = useRef<HTMLLIElement>(null);
  const separatorRef2 = useRef<HTMLLIElement>(null);
  const separatorRef3 = useRef<HTMLLIElement>(null);
  const separatorRef4 = useRef<HTMLLIElement>(null);
  const separatorRef5 = useRef<HTMLLIElement>(null);
  const separatorRef6 = useRef<HTMLLIElement>(null);
  const separatorRef7 = useRef<HTMLLIElement>(null);
  const separatorRef8 = useRef<HTMLLIElement>(null);
  const separatorRef9 = useRef<HTMLLIElement>(null);
  const separatorRef10 = useRef<HTMLLIElement>(null);
  const separatorRef11 = useRef<HTMLLIElement>(null);
  const separatorRef12 = useRef<HTMLLIElement>(null);
  const separatorRef13 = useRef<HTMLLIElement>(null);
  const separatorRef14 = useRef<HTMLLIElement>(null);
  const separatorRef15 = useRef<HTMLLIElement>(null);
  const separatorRef16 = useRef<HTMLLIElement>(null);
  const separatorRef17 = useRef<HTMLLIElement>(null);
  const separatorRef18 = useRef<HTMLLIElement>(null);
  const separatorRef19 = useRef<HTMLLIElement>(null);
  const separatorRef20 = useRef<HTMLLIElement>(null);
  const headerRefs = useMemo<HeaderReferences>(
    () =>
      [
        [headerRef1, separatorRef1],
        [headerRef2, separatorRef2],
        [headerRef3, separatorRef3],
        [headerRef4, separatorRef4],
        [headerRef5, separatorRef5],
        [headerRef6, separatorRef6],
        [headerRef7, separatorRef7],
        [headerRef8, separatorRef8],
        [headerRef9, separatorRef9],
        [headerRef10, separatorRef10],
        [headerRef11, separatorRef11],
        [headerRef12, separatorRef12],
        [headerRef13, separatorRef13],
        [headerRef14, separatorRef14],
        [headerRef15, separatorRef15],
        [headerRef16, separatorRef16],
        [headerRef17, separatorRef17],
        [headerRef18, separatorRef18],
        [headerRef19, separatorRef19],
        [headerRef20, separatorRef20],
      ] as const,
    []
  );

  const [backbuttonRefs, setBackbuttonRefs] = useState<
    Array<HTMLSpanElement | null>
  >([]);

  const [stepperReferences, setStepperRefs] = useState<
    Array<HTMLDivElement | null>
  >([]);

  const [stepperSmallRef, setStepperSmallRef] = useState<HTMLDivElement | null>(
    null
  );

  const [activeNavLevels, dispatchActiveNavLevelsAction] = useReducer(
    navlevelsReducer,
    [] as INavLevelEntry[]
  );
  const registerActiveNavLevel = useCallback(
    (level: number, showInBreadcrumb?: boolean) => {
      dispatchActiveNavLevelsAction({ type: 'reg', level, showInBreadcrumb });
    },
    [dispatchActiveNavLevelsAction]
  );

  const unregisterActiveNavLevel = useCallback(
    (level: number, showInBreadcrumb?: boolean) => {
      dispatchActiveNavLevelsAction({ type: 'unreg', level, showInBreadcrumb });
    },
    [dispatchActiveNavLevelsAction]
  );

  const [menuReference, setMenuRef] = useState<HTMLDivElement | null>(null);

  const breadcrumbsContextValue = useMemo<IBreadcrumbsContext>(
    () => ({
      headerReferences: headerRefs,
      backButtonReferences: backbuttonRefs,
      setBackbuttonRefs,
      stepperReferences: stepperReferences,
      setStepperRefs,
      stepperSmallRef,
      setStepperSmallRef,
      menuReference: menuReference,
      setMenuRef,
      topNavLevel: topNavLevel(activeNavLevels),
      topBreadcrumbNavLevel: topBreadcrumbNavLevel(activeNavLevels),
      currentNavLevel: 0,
      registerActiveNavLevel,
      unregisterActiveNavLevel,
    }),
    [
      headerRefs,
      backbuttonRefs,
      setBackbuttonRefs,
      stepperReferences,
      setStepperRefs,
      stepperSmallRef,
      menuReference,
      setMenuRef,
      activeNavLevels,
      registerActiveNavLevel,
      unregisterActiveNavLevel,
    ]
  );

  return (
    <BreadcrumbsContextProvider value={breadcrumbsContextValue}>
      {props.children}
    </BreadcrumbsContextProvider>
  );
};

export default BreadcrumbsWrapper;
